import { render } from "./Snackbar.vue?vue&type=template&id=4a9600ce&ts=true"
import script from "./Snackbar.vue?vue&type=script&lang=ts"
export * from "./Snackbar.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__